(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aadhya-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aadhya-hero')) {
    customElements.define(
      'aadhya-hero',
      class AadhyaHero extends HTMLElement {
        connectedCallback() {
          const video = this.querySelector('video');
          if (!video) return;

          if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
            video.removeAttribute('autoplay');
            video.pause();
            video.classList.add('is-playing');
            return;
          }

          // fade the video in once it actually plays (the still image shows until then)
          const show = () => video.classList.add('is-playing');
          if (video.readyState > 2 && !video.paused) show();
          video.addEventListener('playing', show, { once: true });

          // save data and battery: play only while the hero is on screen
          this.observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) video.play().catch(() => {});
            else video.pause();
          });
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aadhya-offer-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aadhya-offer-bar')) {
    customElements.define(
      'aadhya-offer-bar',
      class AadhyaOfferBar extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.aob__track');
          this.group = this.querySelector('.aob__group');

          this.resize = new ResizeObserver(() => this.measure());
          this.resize.observe(this);
          if (this.group) this.resize.observe(this.group);

          // pause while a finger is on the bar so offers can be read and tapped
          this.addEventListener('touchstart', () => this.setAttribute('data-paused', ''), { passive: true });
          this.addEventListener('touchend', () => {
            clearTimeout(this.resumeTimer);
            this.resumeTimer = setTimeout(() => this.removeAttribute('data-paused'), 2500);
          });

          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-aob-copy]');
            if (!button) return;
            event.preventDefault();
            this.copy(button);
          });

          this.timers = [...this.querySelectorAll('[data-aob-end]')];
          if (this.timers.length) {
            this.tick();
            this.interval = setInterval(() => this.tick(), 1000);
          }
        }

        disconnectedCallback() {
          this.resize?.disconnect();
          clearInterval(this.interval);
          clearTimeout(this.resumeTimer);
        }

        measure() {
          document.documentElement.style.setProperty('--aadhya-offer-h', `${this.offsetHeight}px`);
          if (!this.hasAttribute('data-scroll') || !this.group) return;
          const speed = Number(getComputedStyle(this).getPropertyValue('--aob-speed')) || 40; // px per second
          this.style.setProperty('--aob-duration', `${Math.max(this.group.scrollWidth / speed, 8)}s`);
        }

        tick() {
          const now = Date.now();
          for (const timer of this.timers) {
            const end = Date.parse(timer.dataset.aobEnd);
            if (Number.isNaN(end)) continue;
            let left = Math.max(0, Math.floor((end - now) / 1000));
            if (left === 0 && timer.dataset.aobDone) {
              timer.textContent = timer.dataset.aobDone;
              continue;
            }
            const parts = { d: Math.floor(left / 86400), h: Math.floor((left % 86400) / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
            for (const [unit, value] of Object.entries(parts)) {
              const el = timer.querySelector(`[data-u="${unit}"]`);
              if (el) el.textContent = String(value).padStart(2, '0');
            }
          }
        }

        async copy(button) {
          const code = button.dataset.aobCopy;
          try {
            await navigator.clipboard.writeText(code);
          } catch (e) {
            const field = Object.assign(document.createElement('textarea'), { value: code });
            document.body.append(field);
            field.select();
            document.execCommand('copy');
            field.remove();
          }
          this.querySelectorAll(`[data-aob-copy="${CSS.escape(code)}"]`).forEach((b) => b.setAttribute('data-copied', ''));
          const toast = this.querySelector('.aob__toast');
          if (toast) toast.textContent = `Code ${code} copied`;
          setTimeout(() => {
            this.querySelectorAll('[data-copied]').forEach((b) => b.removeAttribute('data-copied'));
          }, 1800);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
